<template>
  <div id="rightBottom">
    <div>
      <img src="../../assets/images/qq_03.png" alt="" width="55px" height="55px" @click="handleChat">
      <!-- <img  style="CURSOR: pointer" @click="javascript:window.open('http://b.qq.com/webc.htm?new=0&sid=80000816&o=im.qq.com&q=7', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');"  border="0" SRC=http://wpa.qq.com/pa?p=1:80000816:3 alt="点击这里给我发消息"> -->
    </div>
    <div @click="handleTop">
      <img src="../../assets/images/top_06.png" alt="" width="55px" height="55px" style="margin-top: 3px;">
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      botIcon:'',
      browserH:0,
    }
  },
  methods:{
    handleScroll(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
    },
    handleTop(){
      console.log('123')
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0;
      document.body.scrollTop = 0;
    },
    handleChat(){
      // window.open('http://b.qq.com/webc.htm?new=0&sid=80000816&o=im.qq.com&q=7', '_blank', 'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no')
      window.open("http://wpa.qq.com/msgrd?v=3&uin=508983539&site=qq&menu=yes")
    }
  },
  mounted(){
    // window.addEventListener('scroll', this.handleScroll)
    // let botIcon = document.querySelector('#rightBottom')
  }
}
</script>

<style lang="less">
  #rightBottom{
    display: flex;
    flex-direction: column;
    // border: 1px solid #a0a0a0;
    background-color: #fff;
    width: 55px;
    height: 114px;
    position: absolute;
    // right: 3.125%;
    right: 5.8%;
    bottom: 0;
    // transform: translateY(-80%);
    bottom: 285px;
    position: fixed;
    z-index: 99;
    div{
      flex:1;
      width: 100%;
      cursor: pointer;
      &:nth-child(1){
        // border-bottom: 1px solid #a0a0a0;
      }
      // img{
      //   cursor: pointer;
      // }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/rightIcon/RightIcon.vue